import { query } from '@rexlabs/model-generator';
import menusModel from 'data/models/entities/menus';

export const menusQuery = query`{
  ${menusModel} (websiteId: ${(p) => p?.match?.params?.websiteId}) {
    id
    name
  }
}`;
